export default __webpack_public_path__ + "static/media/time.16703388.svg";